import { FC, memo } from "react";

import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import classes from "./rentableGroupCalculatorSelectedGroup.scss";

interface IRentableGroupCalculatorSelectedGroupProps {
  incomeGroup?: string;
  incomeGroupCopy: string;
}

const RentableGroupCalculatorSelectedGroup: FC<IRentableGroupCalculatorSelectedGroupProps> =
  memo(({ incomeGroup, incomeGroupCopy }) => {
    return (
      <section className={classes.root}>
        <RentableGroupCalculatorHtmlContent
          as="p"
          className={classes.paragraph}
          html={incomeGroupCopy}
        />
        {incomeGroup && (
          <span className={classes.highlight}>{incomeGroup}</span>
        )}
      </section>
    );
  });
export default RentableGroupCalculatorSelectedGroup;
